import SimpleParallax from "simple-parallax-js/vanilla";

var imagesFast = document.querySelectorAll('.parallax-fast');
new SimpleParallax(imagesFast, {
    scale: 3,
    orientation: 'up',
    overflow: true
});

var imagesSlow = document.querySelectorAll('.parallax-slow');
new SimpleParallax(imagesSlow, {
    scale: 1.5,
    orientation: 'up',
    overflow: true
});